import { render } from "./CustomAnchorButton.vue?vue&type=template&id=8a8da9ee&scoped=true"
import script from "./CustomAnchorButton.vue?vue&type=script&lang=js"
export * from "./CustomAnchorButton.vue?vue&type=script&lang=js"

import "./CustomAnchorButton.vue?vue&type=style&index=0&id=8a8da9ee&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8da9ee"]])

export default __exports__